export default __webpack_public_path__ + "static/media/Info.8a224f4a.svg";